// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attendance_kindersystems__body{margin:20px 0px}.attendance_kindersystems__title{font-size:13px;font-weight:250;text-transform:uppercase;padding:8px}`, "",{"version":3,"sources":["webpack://./src/modals/AttendanceKinderSystems/style.scss"],"names":[],"mappings":"AAEE,gCACE,eAAA,CAGF,iCACE,cAAA,CACA,eAAA,CACA,wBAAA,CACA,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
